import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const FocusChart = ({ data }) => {
  return (
    <div style={{ width: "100%", height: 300 }}>
      <h3 className="chart-title" >Focus Trend</h3>

      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid stroke="#374151" strokeDasharray="3 3" />

          <XAxis
            stroke="#9ca3af"
            dataKey="date"
            tickFormatter={(date) =>
              new Date(date).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
              })
            }
          />

          <YAxis stroke="#9ca3af" />

          <Tooltip
            labelFormatter={(label) =>
              new Date(label).toLocaleDateString()
            }
          />

          <Line
            type="monotone"
            dataKey="totalMinutes"
            stroke="#6366f1"
            strokeWidth={3}
            dot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FocusChart;